import { jsx, jsxs } from "react/jsx-runtime";
import { convertRangeTo0Based } from "@teselagen/range-utils";
import classNames from "classnames";
import React from "react";
import { reduxForm } from "redux-form";
import { tgFormValues, wrapDialog } from "@teselagen/ui";
import { compose } from "redux";
import { Button, Intent, Classes } from "@blueprintjs/core";
import { NumericInputField } from "@teselagen/ui";
import { get } from "lodash-es";
import { getRangeLength } from "@teselagen/range-utils";
import { tryToRefocusEditor } from "../utils/editorUtils";
const validate = (val, vals, props) => {
  const { min, max } = get(props, "extraProps.from", {});
  const circular = get(props, "extraProps.circular");
  if (min && val < min || max && val > max) {
    return "Invalid position";
  }
  if (!circular && Number(vals.from) > Number(vals.to)) {
    return "Wrong from/to order";
  }
};
export default compose(
  wrapDialog({
    isDraggable: true,
    width: 400,
    title: "Select Range",
    height: 270,
    onCloseHook: tryToRefocusEditor
  }),
  reduxForm({
    form: "selectDialog"
  }),
  tgFormValues("from", "to")
)(
  class SelectDialog extends React.Component {
    updateTempHighlight = ({ isStart, isEnd } = {}) => (val) => {
      const { selectionLayerUpdate, from, to, invalid } = this.props;
      if (invalid) return;
      selectionLayerUpdate(
        convertRangeTo0Based({
          start: isStart ? Math.round(val) : from,
          end: isEnd ? Math.round(val) : to
        })
      );
    };
    componentDidMount() {
      const { from, to, initialCaretPosition } = this.props;
      this.initialSelection = { from, to, initialCaretPosition };
      this.updateTempHighlight()();
    }
    render() {
      const {
        hideModal,
        onSubmit,
        selectionLayerUpdate,
        from,
        to,
        initialCaretPosition,
        caretPositionUpdate,
        sequenceLength,
        extraProps,
        isProtein,
        invalid,
        handleSubmit,
        showAminoAcidUnitAsCodon
      } = this.props;
      const selectionLength = getRangeLength(
        {
          start: Number(from),
          end: Number(to)
        },
        sequenceLength
      );
      return /* @__PURE__ */ jsxs(
        "form",
        {
          onSubmit: handleSubmit((data) => {
            if (onSubmit) onSubmit(data);
            hideModal();
            tryToRefocusEditor();
          }),
          className: classNames(
            Classes.DIALOG_BODY,
            "tg-min-width-dialog simple-dialog"
          ),
          children: [
            /* @__PURE__ */ jsx(
              NumericInputField,
              {
                autoFocus: true,
                minorStepSize: 1,
                label: "From:",
                clampValueOnBlur: true,
                ...extraProps.to,
                validate,
                normalize: normalizeToInt,
                onAnyNumberChange: this.updateTempHighlight({ isStart: true }),
                name: "from"
              }
            ),
            /* @__PURE__ */ jsx(
              NumericInputField,
              {
                label: "To:",
                clampValueOnBlur: true,
                minorStepSize: 1,
                ...extraProps.from,
                validate,
                normalize: normalizeToInt,
                onAnyNumberChange: this.updateTempHighlight({ isEnd: true }),
                name: "to"
              }
            ),
            /* @__PURE__ */ jsxs("div", { className: "dialog-buttons", children: [
              /* @__PURE__ */ jsx(
                Button,
                {
                  onClick: () => {
                    if (initialCaretPosition > -1) {
                      caretPositionUpdate(initialCaretPosition);
                    } else {
                      selectionLayerUpdate({
                        start: this.initialSelection.from,
                        end: this.initialSelection.to
                      });
                    }
                    hideModal();
                    tryToRefocusEditor();
                  },
                  text: "Cancel"
                }
              ),
              /* @__PURE__ */ jsx(
                Button,
                {
                  type: "submit",
                  intent: Intent.PRIMARY,
                  text: `Select ${invalid ? 0 : selectionLength} ${isProtein ? `${showAminoAcidUnitAsCodon ? "codon" : "AA"}` : "BP"}${selectionLength === 1 ? "" : "s"}`,
                  disabled: invalid
                }
              )
            ] })
          ]
        }
      );
    }
  }
);
const normalizeToInt = (val) => {
  const int = Math.round(val);
  const normalizedVal = `${int >= 0 ? int : 1}`;
  return normalizedVal;
};
